import type { ThemeConfig } from "antd";

/**
 * Design tokens from Design Brief v1.1 §3 and §5. This is the only file in the
 * web app allowed to contain hex colours (lint enforces it); components read
 * colours through Ant Design tokens or the CSS variables in styles.css.
 *
 * Light theme only for the MVP (Design Brief §3.5). The dark tokens are locked in
 * the brief and will get their own ThemeConfig after the MVP.
 */
export const palette = {
  tealTua: "#0B5D58", // primary: buttons, links, active menu
  hijauMalam: "#063B38", // text
  tealCerah: "#1FA38F", // accent shapes and icons only, never text on light
  mint: "#E3F3EF", // tinted areas, selected rows
  permukaan: "#F6F9F8", // page background
  abuTeks: "#55706C", // muted text
  garis: "#DDE9E6", // borders
  garisInput: "#B9D1CC", // input borders
  putih: "#FFFFFF",
  success: "#1E7B4A",
  successBg: "#E6F4EA",
  warning: "#8A5B00",
  warningBg: "#FFF4D6",
  error: "#B42318",
  errorBg: "#FDECEA",
} as const;

export const lightTheme: ThemeConfig = {
  token: {
    colorPrimary: palette.tealTua,
    colorLink: palette.tealTua,
    colorSuccess: palette.success,
    colorSuccessBg: palette.successBg,
    colorWarning: palette.warning,
    colorWarningBg: palette.warningBg,
    colorError: palette.error,
    colorErrorBg: palette.errorBg,
    colorInfo: palette.tealTua,
    colorTextBase: palette.hijauMalam,
    colorTextSecondary: palette.abuTeks,
    colorTextDescription: palette.abuTeks,
    colorBgBase: palette.putih,
    colorBgLayout: palette.permukaan,
    colorBorder: palette.garisInput,
    colorBorderSecondary: palette.garis,
    colorSplit: palette.garis,

    borderRadius: 10, // controls
    borderRadiusLG: 16, // cards
    borderRadiusSM: 8,

    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontSize: 14, // desktop app base; landing and mobile use 16
    controlHeight: 40, // standard
    controlHeightSM: 32, // compact
    controlHeightLG: 48, // large actions only

    boxShadow: "none",
    boxShadowSecondary: "0 1px 2px rgba(6,59,56,.06), 0 8px 24px -12px rgba(6,59,56,.25)",
  },
  components: {
    Modal: { borderRadiusLG: 20 },
    Layout: { siderBg: palette.putih, headerBg: palette.putih, bodyBg: palette.permukaan },
    Menu: {
      itemSelectedBg: palette.mint,
      itemSelectedColor: palette.tealTua,
      itemHoverBg: palette.permukaan,
      itemBorderRadius: 10,
    },
    Table: { headerBg: palette.permukaan, rowSelectedBg: palette.mint, rowSelectedHoverBg: palette.mint },
    Button: { fontWeight: 700, primaryShadow: "none", defaultShadow: "none" },
    Card: { headerFontSize: 16 },
  },
};
